import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { VariantProvider } from './context/VariantContext';
import './styles/main.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <VariantProvider>
      <App />
    </VariantProvider>
  </React.StrictMode>
);
